module.exports = __webpack_public_path__ + "img/img-intersection@3x.faf557ed.png";